import React from 'react';
import { CountdownBar } from './CountdownBar';
import { HeroSection } from './HeroSection';
import { LearnSection } from './LearnSection';
import { PainSection } from './PainSection';
import { SolutionSection } from './SolutionSection';
import { IncludesSection } from './IncludesSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { UpgradeSection } from './UpgradeSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
import { SocialProofPopup } from './SocialProofPopup';
import { MetaPixel } from './MetaPixel';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-241">
      <MetaPixel data-id="element-242" />
      <CountdownBar data-id="element-243" />

      <main data-id="element-244">
        <HeroSection data-id="element-245" />
        <LearnSection data-id="element-246" />
        <PainSection data-id="element-247" />
        <SolutionSection data-id="element-248" />
        <IncludesSection data-id="element-249" />
        <BeforeAfterSection data-id="element-250" />
        <BonusSection data-id="element-251" />
        <PricingSection data-id="element-252" />
        <UpgradeSection data-id="element-253" />
        <GuaranteeSection data-id="element-254" />
        <TestimonialsSection data-id="element-255" />
        <FAQSection data-id="element-256" />
        <FinalCTA data-id="element-257" />
      </main>

      <FooterSection data-id="element-258" />
      <SocialProofPopup data-id="element-259" />
    </div>;
}